(() => {
  const fix = () => {
    const link = document.querySelector('a[href*="/policies/privacy-policy"]');
    if (link && link.textContent.trim().toLowerCase() === 'learn more') {
      link.textContent = 'Privacy Policy';
      link.setAttribute('aria-label', 'Privacy Policy');
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix, { once: true });
  } else {
    fix();
  }
  window.addEventListener('load', fix, { once: true });
  window.setTimeout(fix, 1500);
  window.setTimeout(fix, 3500);
})();
